/* Kinaura Life — Footer
   Suscripcion al newsletter contra la API publica de cliente de Klaviyo.
   Si la seccion no tiene company id o lista, el formulario avisa y no envia nada. */
(function () {
  'use strict';

  function initFooterForms(root) {
    var forms = (root || document).querySelectorAll('[data-kf-klaviyo]:not([data-kf-done])');
    Array.prototype.forEach.call(forms, function (form) {
      form.setAttribute('data-kf-done', '1');
      var key = (form.getAttribute('data-kf-klaviyo') || '').trim();
      var lists = (form.getAttribute('data-kf-lists') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button');
      var msg = form.querySelector('.kf-msg');

      function say(text, err) {
        if (!msg) return;
        msg.textContent = text;
        msg.className = 'kf-msg is-on' + (err ? ' is-err' : '');
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var email = (input && input.value || '').trim();
        if (!email || email.indexOf('@') < 1) { say('Enter a valid email address.', true); return; }
        if (!key || !lists.length) { say('Sign-ups open soon.', true); return; }

        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Sending'; }

        Promise.all(lists.map(function (id) {
          return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + key, {
            method: 'POST',
            headers: { 'content-type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: form.getAttribute('data-kf-source') || 'Footer newsletter',
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: { list: { data: { type: 'list', id: id } } }
              }
            })
          });
        })).then(function (res) {
          var ok = res.every(function (r) { return r.ok || r.status === 202; });
          if (!ok) throw new Error('bad status');
          say('Check your inbox. Your code is on the way.');
          form.reset();
        }).catch(function () {
          say('Something went wrong. Please try again or email hello@kinauralife.com', true);
        }).then(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFooterForms(document); });
  } else {
    initFooterForms(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initFooterForms(e.target); });
})();
